
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';


import './error4049ddqy.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Perror4049ddqy = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6942dbbe599f24ea479be76a" >

      <div id="icuq" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/aboutus"
        type=""
      >
        <>Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/services"
        type=""
      >
        <>Servicios</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactus"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ibznw" className="">
      
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgsvh2.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href={`/`}
        >
          
    <div id="iye9" className="">
    <>Ini</>
      <a
        target=""
        className=""
        id="id3bxh"
        href=""
        type=""
      >
        
      </a>
      <>cio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href={`/aboutus`}
        >
          
    <div id="i8s6k" className="">
    <>Nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href={`/services`}
        >
          
    <div id="ib721" className="">
    <>Servicios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>Blog</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactus"
        >
          
    <div id="ii21f" className="">
    <>Contacto</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="ib6b7" className="">
      
      <div id="iv94u" className="">
      
      <img
        className=""
        id="iwpbk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgxdbe.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i7dif"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgph1jxm.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ixytr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpgza38.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i7c4v6" className="">
      
      <div id="i8nnot" className="">
      
      <div id="i5pkmz" className="">
      
      <div id="iu1q1o" className="">
      
      <img
        className=""
        id="ilt29"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja92k5o.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iye8ax" className="">
      
      <div id="ikl1x" className="">
      
      <img
        className=""
        id="iz4ug"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgv0dbfs.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i76c6" className="">
      
      <img
        className=""
        id="ivge2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgv0ifmu.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iprrvj" className="">
      
      <img
        className=""
        id="ibf8h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgv0dbfs.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ic97gb" className="">
      
      <img
        className=""
        id="ic6mqg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgv0kxiu.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i79jn" className="">
      
      <img
        className=""
        id="isbis6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjauja5o.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i1vx6j" className="">
      
      <div className="" id="iuz1ym">
        <>¡Ups! Página no encontrada</>
      </div>
      <>
        </>
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <div className="" id="i34fxz">
        <>Parece que la dirección que buscaste no existe o fue movida.</>
      </div>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ihuib5" className="">
      
        <a
          target=""
          className=""
          id="ifi8zf"
          href="/"
        >
          
      <span className="" id="icertu">
        <>Página de inicio</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Perror4049ddqy);
  